<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Brands & Product Inventory</h1>

    <div class="grid md:grid-cols-3 lg:grid-cols-6 gap-2">

      <inertia-link :href="route('admin.inventory.brands')" class="p-4 border rounded bg-green-300 hover:bg-green-600 hover:text-white">List by Brands</inertia-link>
      <inertia-link :href="route('admin.inventory.countries')" class="p-4 border rounded bg-blue-400 hover:bg-blue-700 hover:text-white">List by Countries</inertia-link>

    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  export default {
    layout: Layout
  }
</script>
